import {createSelector} from 'reselect';
import {getCurrentPreviewIssueId} from './currentPreviewIssue-selectors';

export const getAttachmentUpload = state => state.attachmentUpload;

export const isUploadingAttachments = createSelector(
  getAttachmentUpload,
  (state, origin) => origin,
  (attachmentUpload, origin) => {
    const uploadingAttachmentsArray = attachmentUpload.uploadingAttachments
      ? attachmentUpload.uploadingAttachments
      : [];
    return !!uploadingAttachmentsArray.find(obj => obj.origin === origin && obj.isSaving);
  }
);

export const getUploadingAttachments = createSelector(
  getAttachmentUpload,
  getCurrentPreviewIssueId,
  (attachmentUpload, issuesId) => {
    const uploadingAttachments = attachmentUpload.uploadingAttachments
      ? attachmentUpload.uploadingAttachments.filter(attachment => attachment.issueId === issuesId)
      : [];
    return uploadingAttachments;
  }
);
